import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Client } from './client.model';

export interface ClientState extends EntityState<Client, string>, ActiveState {
    currentClient: Client;
    currentPage: number;
    pages: number;
    name: string;
    pdfURL: string;
    availableStore: number;
    signatureAdvanced: boolean;
    deviceKey: string;
    userSearch: string;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'clients' })
export class ClientStore extends EntityStore<ClientState> {
    constructor() {
        super({
            currentClient: null,
            currentPage: 0,
            pages: 0,
            name: '',
            pdfURL: '',
            availableStore: 0,
            signatureAdvanced: false,
            deviceKey: '',
            userSearch: ''
        });
    }
}
